module.exports = __webpack_public_path__ + "img/1thee3logo.e56a9b6d.webp";